<template>
  <div class="container-fluid mtb15 no-fluid">
    <div class="row sm-gutters">
      <!-- Menu -->
      <div v-if="1200 < getWindowsWidth" class="col-sm-12 col-md-2">
        <AppMenu></AppMenu>
      </div>
      <!-- Profile -->
      <div class="col-sm-12" :class="{ 'col-md-10': 1200 < getWindowsWidth }">
        <div class="settings mtb15">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-2">
                <ul class="nav nav-tabs nav-pills" 
                  :class="{ 'settings-nav': 1200 < getWindowsWidth, 'show_list_horizontal text-nowrap': 1200 > getWindowsWidth }"
                  id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button class="nav-link" :class="{ 'active': 'main' === currentMenuItem, 'xsmall-font-size': 1200 > getWindowsWidth }" id="Main-tab"
                      type="button" role="tab" aria-controls="Main"
                      :aria-selected="'main' === currentMenuItem"
                      @click.prevent="selectMenuItem('main')">
                      {{ getMainLabel.toUpperCase() }}
                    </button>
                  </li>                  
                  <li class="nav-item" role="presentation">
                    <button class="nav-link" :class="{ 'active': 'language' === currentMenuItem, 'xsmall-font-size': 1200 > getWindowsWidth }" id="Language-tab"
                      type="button" role="tab" aria-controls="Language"
                      :aria-selected="'language' === currentMenuItem"
                      @click.prevent="selectMenuItem('language')">
                      {{ getLanguageLabel.toUpperCase() }}
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link" :class="{ 'active': 'password' === currentMenuItem, 'xsmall-font-size': 1200 > getWindowsWidth }" id="Password-tab"
                      type="button" role="tab" aria-controls="Password"
                      :aria-selected="'password' === currentMenuItem"
                      @click.prevent="selectMenuItem('password')">
                      {{ getPasswordLabel.toUpperCase() }}
                    </button>
                  </li>
                  <li v-if="1 === this.getUserType()" class="nav-item" role="presentation">
                    <a class="nav-link" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }" target="_blank" rel="noopener noreferrer" href="https://payments.eurofinance.bg/">
                      {{ getAddFundsLabel.toUpperCase() }}
                    </a>
                  </li>
                  <li v-if="1 === this.getUserType()" class="nav-item" role="presentation">
                    <button class="nav-link" :class="{ 'active': 'withdraw' === currentMenuItem, 'xsmall-font-size': 1200 > getWindowsWidth }" id="Withdraw-tab"
                      type="button" role="tab" aria-controls="Withdraw"
                      :aria-selected="'withdraw' === currentMenuItem"
                      @click.prevent="selectMenuItem('withdraw')">
                      {{ getWithdrawLabel.toUpperCase() }}
                    </button>
                  </li>
                </ul>
              </div>
              <div class="col-lg-10">
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade"
                    :class="{ 'show': 'main' === currentMenuItem, 'active': 'main' === currentMenuItem }"
                    id="Main" role="tabpanel" aria-labelledby="Main-tab">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">{{ getMainLabel }}</h5>
                        <div class="settings-profile">
                          <form>
                            <div class="row">
                              <div class="col-md-12 mt15">
                                <div class="container">
                                  <div class="img-overlay-wrap">
                                    <img width="100" src="@/assets/images/EFOCS_Avatar.svg" class=" rounded-circle" alt="avatar" />
                                    <svg class="svg-rect" width="100" height="20">                      
                                        <rect x="0" y="0" rx="3" ry="3" width="100" height="20" :fill="getUserTypeFillColor"></rect>
                                        <text class="avatar_text pt-4" x="50%" y="50%" text-anchor="middle" stroke="white" stroke-width="1px" dy=".3em">{{ getUserTypeString }}</text>
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-12 mt15">
                                <label for="userId">{{ getClientNumberLabel }}</label>
                                <input id="userId" type="text" class="form-control" :value="getUserIdForDisplay(getUser?.id)" disabled />
                              </div>
                              <div class="col-md-12 mt15">
                                <label for="userName">{{ getNameLabel }}</label>
                                <input id="userName" type="text" class="form-control" :value="getUser?.name" disabled />
                              </div>
                              <div v-if="0 === getUserType()" class="col-md-12 mt15">
                                <label for="userPhone">{{ getPhoneLabel }}</label>
                                <input id="userPhone" type="text" class="form-control" :value="getUser?.phone" disabled />
                              </div>
                              <div v-if="0 === getUserType()" class="col-md-12 mt15">
                                <label for="userEmail">{{ getEmailLabel }}</label>
                                <input id="userEmail" type="text" class="form-control" :value="getUser?.email" disabled />
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div class="profile-branding" aria-label="Application information">
                      <div class="profile-branding-row">
                        <span>Version {{ appVersion }}</span>
                        <span>|</span>
                        <span>Created by</span>
                        <img class="profile-whiz-logo" :src="whizLogo" alt="WHIZ" />
                      </div>
                      <div class="profile-branding-row">
                        <span>Powered by</span>
                        <a class="profile-branding-link" :href="euroFinanceUrl" target="_blank" rel="noopener noreferrer">
                          <img :src="xallLogo" alt="EuroFinance" />
                          <span>EuroFinance</span>
                        </a>
                      </div>
                    </div>
                  </div>                  
                  <div class="tab-pane fade"
                    :class="{ 'show': 'password' === currentMenuItem, 'active': 'password' === currentMenuItem }"
                    id="Password" role="tabpanel" aria-labelledby="Password-tab">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">{{ getPasswordLabel }}</h5>
                        <div class="settings-profile">
                          <form>
                            <div class="row">
                              <div class="col-md-12 mt15">
                                <label for="currentPass">
                                  {{ getCurrentPasswordLabel }}
                                </label>
                                <input id="currentPass" type="password" class="form-control"
                                  :placeholder="getCurrentPasswordLabel" v-model="oldPassword" />
                              </div>
                              <div class="col-md-12 mt15">
                                <label for="newPass">{{ getNewPasswordLabel }}</label>
                                <input id="newPass" type="password" class="form-control"
                                  :placeholder="getNewPasswordLabel" v-model="newPassword" />
                              </div>
                              <div class="col-md-12 mt15">
                                <label for="repeatNewPass">{{ getRepeatPasswordPlaceHolder }}</label>
                                <input id="repeatNewPass" type="password" class="form-control"
                                  :placeholder="getRepeatPasswordPlaceHolder" v-model="repeatNewPassword" />
                              </div>
                              <div class="col-md-12 mt15">
                                <input type="submit" :value="getConfirmLabel" :disabled="canUpdatePassword"
                                  @click.prevent="updatePassword" />
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade"
                    :class="{ 'show': 'language' === currentMenuItem, 'active': 'language' === currentMenuItem }"
                    id="Language" role="tabpanel" aria-labelledby="Language-tab">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">{{ getLanguageLabel }}</h5>
                        <div class="settings-profile">
                          <form>
                            <div class="row mt-4">
                              <div class="col-md-12">
                                <label class="btn" for="langBg" :class="{ 'w-100': 1200 > getWindowsWidth, 'w-25': 1200 < getWindowsWidth, 'btn-outline-primary': 'BG' !== language, 'btn-primary': 'BG' === language }">
                                  <div class="input-group">
                                    <div class="input-group-prepend">
                                      <img src="@/assets/images/Bulgarian.svg" class="lang_flag" alt="language" />
                                    </div>
                                    &nbsp;Български
                                  </div>
                                </label>
                                <input type="radio" class="btn-check" id="langBg" value="BG" v-model="language" autocomplete="off"><br />
                                <label class="btn" for="langEn" :class="{ 'w-100': 1200 > getWindowsWidth, 'w-25': 1200 < getWindowsWidth, 'btn-outline-primary' : 'EN' !== language, 'btn-primary': 'EN' === language}">
                                  <div class="input-group">
                                    <div class="input-group-prepend">
                                      <img src="@/assets/images/English.svg" class="lang_flag" alt="language" />
                                    </div>
                                    &nbsp;English
                                  </div>
                                </label>
                                <input type="radio" class="btn-check" id="langEn" autocomplete="off" value="EN" v-model="language">
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade"
                    :class="{ 'show': 'withdraw' === currentMenuItem, 'active': 'withdraw' === currentMenuItem }"
                    id="Withdraw" role="tabpanel" aria-labelledby="Withdraw-tab">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">{{ getWithdrawLabel }}</h5>
                        <div class="settings-profile">
                          <form>
                            <div class="row">
                              <div class="col-md-12 mt15">
                                <div v-if="!userBankAccounts">{{ getNoBankAccountsLabel }}</div>
                                <div v-else>
                                  <table class="table is-full-width">
                                    <thead>
                                      <tr>
                                        <th>{{ getIbanAccountNumberLabel }}</th>
                                        <th>{{ getCurrencyLabel }}</th>
                                        <th>{{ getBankLabel }}</th>
                                        <th>{{ getAvailableToWithdrawLabel }}</th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="account in userBankAccounts" :key="account.accId">
                                        <td>{{ account.acc }}</td>
                                        <td>{{ account.cc }}</td>
                                        <td>{{ account.bank }}</td>
                                        <td>{{ formatPrice(getAvailableMoneyInCurrency(account.cc), account.cc, 2).replace(" ", "&nbsp;") }}</td>
                                        <td>
                                          <div class="btn">
                                            <a role="button" class="btn btn-link" 
                                              data-bs-toggle="collapse" href="#collapseWithdrawSection" 
                                              :aria-expanded="showWithdrawFrom" aria-controls="collapseWithdrawSection"
                                              @click.prevent="showWithdrawFrom = !showWithdrawFrom; selectedAccountCurrency = account.cc; selectedAccountAmount = getAvailableMoneyInCurrency(account.cc); maxAccountAmount = selectedAccountAmount; selectedAccountId = account.accId;">
                                              <i v-if="showWithdrawFrom" class="icon ion-md-arrow-up"></i>
                                              <i v-else class="icon ion-md-arrow-down"></i>
                                            </a>
                                          </div>                                          
                                        </td>
                                      </tr>
                                      <tr class="collapse" :class="{ 'show': showWithdrawFrom === true }" id="collapseWithdrawSection">
                                        <td colspan="5">
                                          <div class="card h-100">
                                            <div class="card-body withdraw-form">
                                              <div class="container">
                                                <div class="row">
                                                  <div class="col-12">
                                                    {{ getWithdrawNoticeLabel }}
                                                  </div>
                                                </div><br />
                                                <div class="row">
                                                  <div class="col-12">
                                                    <label style="margin-top: 15px;" for="amountToWithdraw">{{getWithdrawAmountLabel}}</label>
                                                    <input id="amountToWithdraw" type="text" inputmode="decimal" class="form-control" min="0.01" :max="maxAccountAmount" step="0.01" v-model="selectedAccountAmount" :value="selectedAccountAmount" @input="normalizeWithdrawAmount" @focusout="allowedValueFocusLost" @keypress="checkMaximumAllowedValue" required />
                                                  </div>
                                                  <div class="col-12">
                                                    <label style="margin-top: 15px;" for="referenceNote">{{getReferenceLabel}}</label>
                                                    <input id="referenceNote" type="text" class="form-control" :placeholder="getWithdrawReferenceDefaultText" v-model="withdrawNote" required />
                                                  </div>
                                                  <div class="col-12">
                                                    <button type="submit" style="margin-top: 15px;" class="btn btn-primary w-100" :disabled="!isWithdrawAmountValid" @click.prevent="sendWithdrawRequest">{{getSubmitLabel}}</button>                                                    
                                                  </div>
                                                </div>
                                                <div v-if="withdrawRequests.length" class="withdraw-requests mt15">
                                                  <h6>{{ getWithdrawRequestsDuringSessionLabel }}</h6>
                                                  <div v-for="group in withdrawRequestsByAccount" :key="group.account" class="withdraw-request-group">
                                                    <table class="table">
                                                      <thead>
                                                        <tr>
                                                          <th>#</th>
                                                          <th>{{ t("timestampLabel") }}</th>
                                                          <th>{{ getCurrencyLabel }}</th>
                                                          <th>{{ getWithdrawAmountLabel }}</th>
                                                          <th>{{ getReferenceLabel }}</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr v-for="(request, index) in group.requests" :key="request.id">
                                                          <td>{{ index + 1 }}</td>
                                                          <td>{{ formatWithdrawRequestDate(request.requestedAt) }}</td>
                                                          <td>{{ request.currency }}</td>
                                                          <td>{{ formatPrice(request.amount, request.currency, 2).replace(" ", "&nbsp;") }}</td>
                                                          <td>{{ request.reference }}</td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/api/http-common";
import AppMenu from '@/components/ui/AppMenu.vue';
import I18n from "@/lang/i18n.js";
import ApiUtils from "@/assets/js/api_utils.js";
import HttpUtils from "@/assets/js/http_utils.js";
import UiUtils from "@/assets/js/ui_utils.js";
import packageInfo from "../../../package.json";
import whizLogo from "@/assets/images/WHIZ_Logo.svg";
import xallLogo from "@/assets/images/XALL-EF.svg";

export default {
  components: {
    AppMenu
  },
  props: {
    selectedMenuItem: {
      required: false,
      type: String,
      default: "password"
    }
  },  
  data() {
    return {
      oldPassword: "", 
      newPassword: "", 
      repeatNewPassword: "",
      language: this.getUserLanguage(), 
//      currentMenuItem: "" === this.selectedMenuItem ? "password" : this.selectedMenuItem,
      disabled: false,
      timeout: null,
      userBankAccounts: {},
      showWithdrawFrom: false,
      selectedAccountCurrency: null,
      maxAccountAmount: null,
      selectedAccountAmount: 0,
      withdrawNote: null,
      selectedAccountId: null,
      appVersion: packageInfo.version,
      whizLogo,
      xallLogo
    }
  },
  watch: {
    language: function (newVal) {
      (async () => await this.updateLanguage(newVal))();
    }
  },
  computed: {
    getWindowsWidth() {
      return this.$store.getters["getAppWindowWidth"] || window.innerWidth;
    },       
    getUserTypeFillColor() {
      const userType = this.$store.getters["getUserType"];
      return 0 === userType ?
        "#0F7392" :
        "#EC6024";
    },
    getUserTypeString() {
      const userType = this.$store.getters["getUserType"];
      return 0 === userType ?
        "DEMO" :
        "LIVE";
    },    
    currentMenuItem() {
      const q = this.$route.query.selectedMenuItem;
      return (Array.isArray(q) ? q[0] : q) || "password";
    },
    euroFinanceUrl() {
      return "EN" === this.getUserLanguage()
        ? "https://eurofinance.bg/en/"
        : "https://eurofinance.bg";
    },
    canUpdatePassword() {
      return !this.oldPassword || !this.newPassword || 0 !== this.newPassword.localeCompare(this.repeatNewPassword);
    },
    isWithdrawAmountValid() {
      const amount = Number.parseFloat(String(this.selectedAccountAmount).replace(",", "."));
      return Number.isFinite(amount) && amount > 0 && amount <= Number(this.maxAccountAmount);
    },
    getGeneralInformationLabel() {
      return this.t("generalInformationLabel");
    },
    getSecurityInformationLabel() {
      return this.t("securityInformationLabel");
    },
    getLanguageLabel() {
      return this.t("languageLabel");
    },
    getCurrencyLabel() {
      return this.t("currencyLabel");
    },
    getBankLabel() {
      return this.t("bankLabel");
    },    
    getIbanAccountNumberLabel() {
      return this.t("ibanAccountNumberLabel");
    },
    getAvailableToWithdrawLabel() {
      return this.t("availableToWithdrawLabel");
    },
    getNoBankAccountsLabel() {
      return this.t("noBankAccountsLabel");
    },    
    getBaseCurrencyLabel() {
      return this.t("baseCurrencyLabel");
    },    
    getConfirmLabel() {
      return this.t("confirmLabel");
    },
    getCurrentPasswordLabel() {
      return this.t("currentPasswordLabel");
    },
    getPasswordLabel() {
      return this.t("passwordLabel");
    },
    getAddFundsLabel() {
      return this.t("addFundsLabel");
    },
    getWithdrawLabel() {
      return this.t("withdrawLabel");
    },
    getNewPasswordLabel() {
      return this.t("newPasswordLabel");
    },
    getProfileLabel() {
      return this.t("profileLabel");
    },
    getPasswordPlaceHolder() {
      return this.t("passwordPlaceHolder");
    },
    getRepeatPasswordPlaceHolder() {
      return this.t("repeatPasswordPlaceHolder");
    },
    getCouldNotUpdatePasswordMessage() {
      return this.t("couldNotUpdatePasswordMessage");
    },
    getPasswordUpdatedMessage() {
      return this.t("passwordUpdatedMessage");
    },
    getCouldNotUpdateLanguageMessage() {
      return this.t("couldNotUpdateLanguageMessage");
    }, 
    getLanguageUpdatedMessage() {
      return this.t("languageUpdatedMessage");
    }, 
    getMainLabel() {
      return this.t("mainLabel");
    },
    getUser() {
      return this.$store.getters["getUser"];
    },
    getDemoLabel() {
      return this.t("demoLabel");
    }, 
    getLiveLabel() {
      return this.t("liveLabel");
    }, 
    getClientNumberLabel() {
      return this.t("clientNumberLabel");
    },
    getNameLabel() {
      return this.t("nameLabel");
    },
    getPhoneLabel() {
      return this.t("phoneLabel");
    },
    getEmailLabel() {
      return this.t("emailLabel");
    },
    getInvalidSessionLabel() {
      return this.t("invalidSessionLabel");
    },
    getWithdrawNoticeLabel() {
      return this.t("withdrawNoticeLabel");
    },
    getReferenceLabel() {
      return this.t("referenceLabel");
    },
    getWithdrawReferenceDefaultText() {
      return this.t("withdrawReferenceDefaultText");
    },
    getAmountLabel() {
      return this.t("amountLabel");
    },
    getWithdrawAmountLabel() {
      return this.t("withdrawAmountLabel");
    },
    getSubmitLabel() {
      return this.t("submitLabel");
    },
    getProcessingWithdrawRequestText() {
      return this.t("processingWithdrawRequestText");
    },
    withdrawRequests() {
      return this.$store.getters["getWithdrawRequests"];
    },
    withdrawRequestsByAccount() {
      return this.withdrawRequests.reduce((groups, request) => {
        const account = request.account || "";
        let group = groups.find(item => item.account === account);
        if (!group) {
          group = { account, requests: [] };
          groups.push(group);
        }
        group.requests.push(request);
        return groups;
      }, []);
    },
    getWithdrawRequestsDuringSessionLabel() {
      return this.t("withdrawRequestsDuringSessionLabel");
    }
  },
  methods: {
    selectMenuItem(menuItem) {
      if (menuItem === this.currentMenuItem) {
        return;
      }

      this.$router.replace({
        name: "Profile",
        query: {
          ...this.$route.query,
          selectedMenuItem: menuItem
        }
      });
    },
    t(key, ...args) {
      const language = typeof this.getUserLanguage === "function" ? this.getUserLanguage() : this.getUserLanguage;
      return I18n.t(key, language, ...args);
    },
    getUserType() {
      return this.$store.getters["getUserType"];
    },    
    async updatePassword() {
      const user = this.$store.getters["getUser"];
      // change password
      try {
        const res = await http.getApiClient(this.getUserType()).get("", {
          params: {
            a: "change_password",
            id: user.id,
            key: user.key,
            opw: this.oldPassword,
            npw: this.newPassword
          }
        });
        // forbid user to click again
        this.oldPassword = "";
        this.newPassword = "";
        if (res) {
          // check answer
          if (ApiUtils.handleTraderNonRecoverableError(res, this.$store, this.$router, this.getUserLanguage)) {
            this.$store.commit("setAppStateReady");
            return;
          }
          if (ApiUtils.isApiResponseInvalidSession(res)) {
            this.$store.commit("setAppStateReady");
            // logout
            setTimeout(
              ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
              500);
            return;
          }
          // get the error message if appropriate
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage());          
          if (errorCode === "") {
            this.$toast.success(this.getPasswordUpdatedMessage, {
              "duration": 5000,
              "pauseOnHover": true
            });
            this.$store.commit("addSystemMessage", {
              date: (new Date()).getTime(),
              mess: this.getPasswordUpdatedMessage,
              error: false
            });
          } else {
            this.$toast.error(errorCode, {
              "duration": 5000,
              "pauseOnHover": true
            });
            this.$store.commit("addSystemMessage", {
              date: (new Date()).getTime(),
              mess: errorCode,
              error: true
            });
          }
        }
      } catch (e) {
        console.error(e);
      }   
    },
    async updateLanguage(lang) {
      const user = this.$store.getters["getUser"];
      // set lang
      try {
        this.disabled = true;

        // Re-enable after 5 seconds
        this.timeout = setTimeout(() => {
          this.disabled = false
        }, 2000);

        const res = await http.getApiClient(this.getUserType()).get("", {
          params: {
            a: "set_lang",
            id: user.id,
            key: user.key,
            lang: lang
          }
        });
        if (res) {
          // get the error message if appropriate
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage()); 
          if (ApiUtils.isApiResponseInvalidSession(res)) {
            this.$store.commit("setAppStateReady");
            // logout
            setTimeout(
              ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
              500);
            return;
          }          
          if (errorCode === "") {
            this.$store.commit("updateUserLanguage", this.language);
            this.$toast.success(this.getLanguageUpdatedMessage, {
              "duration": 5000,
              "pauseOnHover": true
            });
            this.$store.commit("addSystemMessage", {
              date: (new Date()).getTime(),
              mess: this.getLanguageUpdatedMessage,
              error: false
            });
          } else {
            this.$toast.error(errorCode, {
              "duration": 5000,
              "pauseOnHover": true
            });
            this.$store.commit("addSystemMessage", {
              date: (new Date()).getTime(),
              mess: errorCode,
              error: true
            });
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getUserBankAccounts() {
      // only live users have withdraw
      if(0 === this.getUserType()) {
        return;
      }
      const user = this.$store.getters["getUser"];
      // set lang
      try {
        this.disabled = true;

        // Re-enable after 5 seconds
        this.timeout = setTimeout(() => {
          this.disabled = false
        }, 2000);

        const res = await http.getApiClient(this.getUserType()).get("", {
          params: {
            a: "get_fin",
            id: user.id,
            key: user.key
          }
        });
        if (res) {
          // get the error message if appropriate
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage()); 
          if (ApiUtils.isApiResponseInvalidSession(res)) {
            this.$store.commit("setAppStateReady");
            // logout
            setTimeout(
              ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
              500);
            return;
          }          
          if (errorCode === "") {
            this.userBankAccounts = res.data.list;
          } else {
            this.$toast.error(errorCode, {
              "duration": 5000,
              "pauseOnHover": true
            });
            this.$store.commit("addSystemMessage", {
              date: (new Date()).getTime(),
              mess: errorCode,
              error: true
            });
          }
        }
      } catch (e) {
        console.error(e);
      }
    },    
    getUserLanguage() {
      return this.$store.getters["getNonLoggedInLanguage"]?.toUpperCase() || "EN";
    },
    getUserIdForDisplay(id) {
      return 0 === this.getUserType()
        ? 'demo-' + id
        : id;
    },
    getAvailableMoneyInCurrency(currency) {
      if (!currency) return 0;

      const userWallet = this.$store.getters["getWallet"];
      const moneyPerCurrency = userWallet?.m?.filter(item => {
        return item?.c?.toLowerCase().localeCompare(currency.toLowerCase()) === 0;
      });
      if (!moneyPerCurrency || 0 === moneyPerCurrency.length) return 0;

      return moneyPerCurrency[0].a;
    },
    formatPrice(val, curr, autoDigits = null) {
      return UiUtils.formatPrice(val, curr, this.getUserLanguage(), autoDigits);
    },
    checkMaximumAllowedValue($event) {
      const keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      const currentValue = String(this.selectedAccountAmount ?? "");
      const isDecimalSeparator = "." === $event.key || "," === $event.key || 46 === keyCode || 44 === keyCode;

      // Allow digits and one decimal separator.
      if (!/^\d$/.test($event.key) && !isDecimalSeparator) {
          $event.preventDefault();
      }
      if (isDecimalSeparator && (currentValue.includes(".") || currentValue.includes(","))) {
        $event.preventDefault();
      }
      if (keyCode >= 48 && keyCode <= 57 && currentValue.includes(".")) {
        const fractionalPart = currentValue.split(".")[1] || "";
        if (2 <= fractionalPart.length) {
          $event.preventDefault();
        }
      }
      if (this.selectedAccountAmount > this.maxAccountAmount) {
        this.selectedAccountAmount = this.maxAccountAmount;
      }
    },
    normalizeWithdrawAmount($event) {
      const input = $event.target;
      const originalValue = String(input.value ?? "");
      const cursorPosition = input.selectionStart ?? originalValue.length;
      const value = originalValue.replace(",", ".");
      let normalizedValue = value.replace(/[^\d.]/g, "");
      const firstDecimalSeparator = normalizedValue.indexOf(".");
      if (0 <= firstDecimalSeparator) {
        normalizedValue = `${normalizedValue.slice(0, firstDecimalSeparator + 1)}${normalizedValue.slice(firstDecimalSeparator + 1).replace(/\./g, "").slice(0, 2)}`;
      }

      this.selectedAccountAmount = normalizedValue;
      const cursorOffset = normalizedValue.length - originalValue.length;
      this.$nextTick(() => {
        const nextCursorPosition = Math.max(0, cursorPosition + cursorOffset);
        input.setSelectionRange(nextCursorPosition, nextCursorPosition);
      });

    },
    allowedValueFocusLost() {
      const amount = Number.parseFloat(String(this.selectedAccountAmount ?? "").replace(",", "."));
      this.selectedAccountAmount = Number.isFinite(amount) && amount > 0 ? amount : "";
    },
    checkReferenceValue($event) {
      const keyCode = ($event.keyCode ? $event.keyCode : $event.which);

      if (!this.withdrawNote && 48 === keyCode) {
          $event.preventDefault();
      }

      if (!this.withdrawNote) {
        this.withdrawNote = this.getWithdrawReferenceDefaultText;
      }
    },
    async sendWithdrawRequest() {
      if (!this.isWithdrawAmountValid) {
        return;
      }
      const user = this.$store.getters["getUser"];
      // send withdraw request
      try {
        this.disabled = true;

        // Re-enable after 2 seconds
        this.timeout = setTimeout(() => {
          this.disabled = false
        }, 2000);

        const reasonForWithdraw = this.withdrawNote ?? this.getWithdrawReferenceDefaultText;

        const res = await http.getApiClient(this.getUserType()).get("", {
          params: {
            a: "withdraw",
            id: user.id,
            key: user.key,
            currency: this.selectedAccountCurrency,
            reason: encodeURIComponent(reasonForWithdraw),
            "account-id": this.selectedAccountId,
            "value-date": new Date().toISOString().split("T")[0], // current date as yyyy-MM-dd
            amount: this.selectedAccountAmount
          }
        });
        if (res) {
          // get the error message if appropriate
          console.log("res: " + JSON.stringify(res.data));
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage()); 
          console.log("error code: " + errorCode);
          if (ApiUtils.isApiResponseInvalidSession(res)) {
            this.$store.commit("setAppStateReady");
            // logout
            setTimeout(
              ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
              500);
            return;
          }
          if (errorCode === "") {
            this.$store.commit("addWithdrawRequest", {
              id: `${Date.now()}-${this.withdrawRequests.length}`,
              requestedAt: Date.now(),
              amount: Number.parseFloat(String(this.selectedAccountAmount).replace(",", ".")),
              currency: this.selectedAccountCurrency,
              account: this.userBankAccounts.find(account => account.accId === this.selectedAccountId)?.acc || "N/A",
              reference: reasonForWithdraw
            });
            this.$toast.success(this.getProcessingWithdrawRequestText, {
              "duration": 5000,
              "pauseOnHover": true
            });
            this.$store.commit("addSystemMessage", {
              date: (new Date()).getTime(),
              mess: this.getProcessingWithdrawRequestText,
              error: false
            });
          } else {
            this.$toast.error(errorCode, {
              "duration": 5000,
              "pauseOnHover": true
            });
            this.$store.commit("addSystemMessage", {
              date: (new Date()).getTime(),
              mess: errorCode,
              error: true
            });
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    formatWithdrawRequestDate(timestamp) {
      return UiUtils.parseUnixTime(Math.floor(Number(timestamp) / 1000));
    }
  },
  async mounted() {
    // load bank accounts
    await this.getUserBankAccounts();
  },
  beforeUnmount() {
    // clear the timeout before the component is destroyed
    clearTimeout(this.timeout);
  }
}
</script>

<style scoped>

input:disabled {
  cursor: not-allowed;
  opacity: 0.2;
  pointer-events: all !important;
}

.lang_flag {
    width: 20px; 
    height: 20px;
}


  .avatar_text {
    top:0;
    left:0;
    font-size: xx-small;
  }

.img-overlay-wrap {
  position: relative;
  display: inline-block; /* <= shrinks container to image size */
  transition: transform 150ms ease-in-out;
}

.img-overlay-wrap img { /* <= optional, for responsiveness */
   display: block;
   max-width: 100%;
   height: auto;
}

.img-overlay-wrap svg {
  position: absolute;
  top: 80%;
  left: 0;
}

  .show_list_horizontal {
      overflow-x: auto; 
      max-width: 100%; 
      max-height: auto; 
      flex: 1; 
      flex-wrap: nowrap;
  }

.xxsmall-font-size {
    font-size: xx-small;
}

.xsmall-font-size {
    font-size: x-small;
} 

.withdraw-form,
.withdraw-form label,
.withdraw-form .form-control,
.withdraw-form .btn {
  font-size: 1rem;
}

.settings-profile label {
  font-size: 1rem;
}

.settings-profile .form-control:disabled {
  color: #000000;
  opacity: 1;
  -webkit-text-fill-color: #000000;
}

.profile-branding {
  color: #000000;
  font-size: 0.625rem;
  margin: 0 auto;
  text-align: left;
}

.profile-branding-row {
  align-items: center;
  display: flex;
  gap: 0.21875rem;
  justify-content: flex-start;
  line-height: 1.8;
}

.profile-branding img {
  height: 12.5px;
  width: auto;
}

.profile-branding a {
  align-items: center;
  color: #134d93;
  display: inline-flex;
  gap: 0.15625rem;
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
}

.profile-branding-link img {
  display: block;
  transform: translateY(-1px);
}

.profile-whiz-logo {
  transform: translateY(-2.5px);
}
</style>
